import axios from "axios"
import config from "../../common/config"
import { Progress } from "../../common/entities/Progress"

export const getGameProgress = (gameId: string): Promise<Progress> => {
  return axios
    .get<Progress>(`${config.api}/progress/${gameId}/`)
    .then((response) => response.data)
}
